module.exports = __webpack_public_path__ + "img/img12.0ac53593.png";